import {makeAutoObservable} from "mobx";

class NavbarStore {
    mobile = true
    navBarShow = false
    currentPage = ``

    constructor() {
        makeAutoObservable(this)
    }

    setMobile(size) {
        this.mobile = size < 1100
        this.navBarShow = !this.mobile;
    }

    setCurrentPage(route) {
        this.currentPage = route
    }

    setShowInMobile(boolean) {
        this.navBarShow = boolean
    }
}

export default new NavbarStore()